import React from 'react'
import SubmitButton from 'components/common/submitButton'
import clsx from 'clsx'
import { useStyles } from './styles.css'
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    useMediaQuery,
    useTheme,
} from '@material-ui/core'
import { Trans } from 'react-i18next'
import LocationForm, { LocationFormState } from 'components/forms/establishment/locationForm'
import CloseButton from 'components/dialogs/closeButton'

interface Props {
    open: boolean
    onClose: () => void
    onSubmit: (values: LocationFormState) => void
    inProgress: boolean
    initialValues: LocationFormState
}

const EstablishmentLocationDialogView: React.FC<Props> = ({ open, onClose, inProgress, ...formData }) => {
    const classes = useStyles()

    const theme = useTheme()
    const fullScreen = useMediaQuery(theme.breakpoints.down('xs'))

    return (
        <Dialog
            open={open}
            onClose={onClose}
            fullScreen={fullScreen}
            scroll="paper"
            classes={{
                paper: classes.paper,
            }}
            maxWidth="md"
        >
            <LocationForm formClassName={classes.form} inProgress={inProgress} {...formData}>
                {(content, actions) => (
                    <>
                        <DialogTitle>
                            <Trans i18nKey="views.establishment.location.title" />{' '}
                            <Trans i18nKey="views.establishment.location.subtitle" />
                        </DialogTitle>
                        <DialogContent dividers>
                            <CloseButton onClose={onClose} />
                            {content}
                        </DialogContent>

                        <DialogActions className={classes.actions}>
                            <Button variant="contained" onClick={onClose}>
                                <Trans i18nKey="actions.cancel" />
                            </Button>
                            {actions.map((action, index) => (
                                <SubmitButton
                                    key={index}
                                    variant="contained"
                                    color="primary"
                                    {...action}
                                    className={clsx(action.className)}
                                >
                                    <Trans i18nKey="actions.validate" />
                                </SubmitButton>
                            ))}
                        </DialogActions>
                    </>
                )}
            </LocationForm>
        </Dialog>
    )
}

export default EstablishmentLocationDialogView
